<template>
	<div>
		<template>
			<yandex-map
				:settings="map.settings"
				:coords="map.coords"
				:zoom="map.zoom"
				:style="{ height: '500px', width: '500px' }"
				@click="clickMap"
				>
				<ymap-marker v-for="marker in map.markers"
					@click="clickMarker"
					@dragend="dragMarker"
					:options="{draggable: true}"
					:key="marker.markerId"
					v-bind="marker"
					/>
			</yandex-map>
		</template>
		<div class="filterForm__search">
			<button
				class="button button-primary btn-sm"
				type="button"
				@click="clickNewMarkerButton">
				Новая метка
			</button>
			<button
				class="btn btn-default --ex-primary"
				type="button"
				@click="clickImportButton">
				Импорт меток
			</button>
			<button
				class="btn btn-default --ex-primary"
				type="button"
				@click="clickExportButton">
				Экспорт меток
			</button>
		</div>
		<h1>Метки на карте</h1>
		<table class="table table-striped">
			<thead>
				<tr>
					<th>
						<span class="link-dotted"
							title="Нажмите, чтобы сортировать по названию"
							@click="sortMarkers('hintContent', map.sortMode)">Название</span>
						<span v-if="map.sortField == 'hintContent' && map.sortMode === true" class="nowrap">
							&nbsp;
							<span class="listColNameIcon">
								<i class="glyphicon glyphicon-triangle-top cursor-pointer"></i>
							</span>
							&nbsp;
						</span>
						<span v-if="map.sortField == 'hintContent' && map.sortMode === false" class="nowrap">
							&nbsp;
							<span class="listColNameIcon">
								<i class="glyphicon glyphicon-triangle-bottom cursor-pointer"></i>
							</span>
							&nbsp;
						</span>
					</th>
					<th>
						<span class="link-dotted"
							title="Нажмите, чтобы сортировать по адресу"
							@click="sortMarkers('address', map.sortMode)">Адрес</span>
						<span v-if="map.sortField == 'address' && map.sortMode === true" class="nowrap">
							&nbsp;
							<span class="listColNameIcon">
								<i class="glyphicon glyphicon-triangle-top cursor-pointer"></i>
							</span>
							&nbsp;
						</span>
						<span v-if="map.sortField == 'address' && map.sortMode === false" class="nowrap">
							&nbsp;
							<span class="listColNameIcon">
								<i class="glyphicon glyphicon-triangle-bottom cursor-pointer"></i>
							</span>
							&nbsp;
						</span>
					</th>
					<th>
						Цвет
					</th>
					<th></th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="marker in map.markers" v-bind="marker">
					<td>
						{{marker.hintContent}}
					</td>
					<td>
						{{marker.address}}
					</td>
					<td>
						<div class="marker-color" :style="{backgroundColor: '#' + marker.color}">
						</div>
					</td>
					<td>
						<button
							class="btn btn-default --ex-primary"
							type="button"
							@click="clickEditButton(marker.markerId)">
							Редактировать
						</button>
					</td>
					<td>
						<button
							class="btn btn-default --ex-primary"
							type="button"
							@click="deleteCurrentMarker(marker.markerId)">
							Удалить
						</button>
					</td>
				</tr>
			</tbody>
		</table>

		<modal :visible.sync="showMarkerPopup">
			<div slot="header" class="row">
				<div class="col-md-12">
					<h4>Свойства метки</h4>
				</div>
				<div class="col-md-12 text-right" style="padding-top: 5px">
					<a class="btn btn-default" @click="toggleMarkerPopup(false)">Отмена</a>
				</div>
			</div>
			<div slot="body">
					<label class="control-label">
						<span title="name">Название</span>
						<b style="color: red;">*</b>
					</label>
					<input 	name="name"
							v-model="currentMarker.hintContent"
							class="form-control d-input" />

					<div class="form-group">
						<div class="col-md-12">
							<label class="control-label">
								<span title="lat">Широта</span>
								<b style="color: red;">*</b>
							</label>
							<input 	name="lat"
									v-model="currentMarker.coords[0]"
									class="form-control d-input"
									type="number"
									placeholder="Широта"
									test-id="input"/>
						</div>
						<div class="col-md-12">
							<label class="control-label">
								<span title="lng">Долгота</span>
								<b style="color: red;">*</b>
							</label>
							<input 	name="lng"
									v-model="currentMarker.coords[1]"
									class="form-control d-input" type="number" placeholder="Долгота" test-id="input"/>
						</div>
					</div>
				<div>
					<label class="control-label">
						<span title="desc">Описание</span>
					</label>
					<textarea name="desc" rows="5" class="form-control d-input" v-model="currentMarker.desc" />
				</div>
				<div>
					<label class="control-label">
						<span title="address">
							Адрес (регион, район, населенный пункт, улица, дом)
						</span>
					</label>
					<input 	name="address"
							v-model="currentMarker.address"
							class="form-control d-input" />
				</div>

				<div class="form-group">
					<div class="col-md-12">
						<label class="control-label">
							<span title="phone">Телефон</span>
						</label>
						<input 	name="phone"
								v-model="currentMarker.phone"
								class="form-control d-input"
								test-id="input"/>
					</div>
					<div class="col-md-12">
						<label class="control-label">
							<span title="site">Сайт</span>
						</label>
						<input 	name="site"
								v-model="currentMarker.site"
								class="form-control d-input"
								test-id="input"/>
					</div>
				</div>
				<div>
					<label class="control-label">
						<span title="site">Цвет метки</span>
					</label>
					<div class="color-chooser" :key="currentMarker.color">
						<div v-for="color in colors" v-bind="color"
							class="color"
							:class="{chosen: color.NAME == currentMarker.color}"
							:style="{backgroundColor: '#'+color.NAME}"
							:data-name="color.NAME"
							@click="changeMarkerColor">
							&nbsp;
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-default" type="button" @click="createEditMarker('create')" v-if="!currentMarker.markerId">
					Создать
				</button>
				&nbsp;
				<button class="btn btn-default" type="button" @click="createEditMarker('edit')" v-if="currentMarker.markerId">
					Сохранить
				</button>
				&nbsp;
				<button class="btn btn-default" type="button" @click="deleteCurrentMarker(currentMarker.markerId)" v-if="currentMarker.markerId">
					Удалить
				</button>
				&nbsp;
			</div>
		</modal>
		<modal :visible.sync="showImportExportPopup">
			<div slot="header" class="row">
				<div class="col-md-12">
					<h4>Импорт/Экспорт</h4>
				</div>
				<div class="col-md-12 text-right" style="padding-top: 5px">
					<a class="btn btn-default" @click="toggleImportExportPopup(false)">Отмена</a>
				</div>
			</div>
			<div slot="body">
				<div>
					<label class="control-label">
						<span title="name">Код карты</span>
					</label>
				</div>
				<textarea name="desc" rows="25" class="form-control d-input" v-model="markersExp" />
			</div>
			<div slot="footer" v-if="isImport">
				<button class="btn btn-default" type="button" @click="clickSaveMarkersButton">
				 	Сохранить
				</button>
			</div>
		</modal>
	</div>
</template>

<script>
	import ctrlMixins from './../_mixins.js'
	import modal from './../../modal.vue'
	import { yandexMap, ymapMarker } from 'vue-yandex-maps'
	import axios from 'axios'
	import urlUtil from '@uarm/src/util-url.js'

	export default {
		name: 'spc_interactive_maps',
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: ''
			},
		},
		data: function(){
			var mapObj, markersNum
			if (!this.value) {
				mapObj = {coords:  ['55.75118367212938','37.62372495674407'],
					zoom: 17,
					markers: [],
					sortMode: null,
					sortField: null,
					settings: {
						apiKey: 'b0aed604-d757-4382-a232-bb84da1351ed',
  						lang: 'ru_RU',
  						coordorder: 'latlong',
  						version: '2.1'
					},
				}
				markersNum = 0
			}
			else {
				mapObj = JSON.parse(this.value.replace(/\\"/g,"'").replace(/">/g,"'>")) //допилить UARM на тему экранирования последней кавычки в ссылке CWP-16144
				markersNum = mapObj.markers.reduce(function(acc, curr) {
						if (acc > curr.markerId) {
							return acc
						} else {
							return curr.markerId
						}
					}, 0)
			}
			return {
				map: mapObj,
				markersCount: markersNum,
				currentMarker: {
					markerId: null,
					hintContent: null,
					coords: [null, null],
					address: null,
					phone: null,
					site: null,
					desc: null,
					color: null,
				},
				markersExp: [],
				showMarkerPopup: false,
				showImportExportPopup: false,
				isImport: false,
				colors: [],
			}
		},
		methods: {
			/*
				Сохранение нового маркера или изменений в старом маркере, срабатывает по нажатию кнопки "Создать" или "Сохранить"
				mode -- 'edit' или 'create', сохранить или создать новый соответсвенно
			*/
			createEditMarker: function(mode) {
				if (this.currentMarker.hintContent
					&& this.currentMarker.coords[0]
					&& this.currentMarker.coords[1]
					&& !(Math.abs(this.currentMarker.coords[0]) > 85)) {
					if (mode == 'create') {
						this.markersCount ++
						this.currentMarker.markerId = this.markersCount
						this.map.markers.push(this.currentMarker)
					} else {
						this.updateMarkDataById(this.currentMarker.markerId)
					}
					this.setMapBounds()
					this.c_value_map = this.map
					this.toggleMarkerPopup(false)
				} else {
					if (!this.currentMarker.hintContent) alert('Не заполнено обязательное поле Название')
					if (!this.currentMarker.coords[0]) alert('Не заполнено обязательное поле Широта')
					if (!this.currentMarker.coords[1]) alert('Не заполнено обязательное поле Долгота')
					if (Math.abs(this.currentMarker.coords[0]) > 85) alert('Широта за границами допустимого диапазона')
				}

			},
			/*
				Открытие\закрытие модального окна
			*/
			toggleMarkerPopup: function(bShow) {
				this.showMarkerPopup = !!bShow;
			},
			/*
				Создание нового маркера по клику на карту
			*/
			clickMap: function(e) {
				this.clearCurrentMarker()
				this.currentMarker.coords = e.get('coords')
				this.currentMarker.color = this.colors[0].NAME
				this.toggleMarkerPopup(true)
			},
			/*
				Создание нового маркера по клику на кнопку "Новый маркер"
			*/
			clickNewMarkerButton: function() {
				this.clearCurrentMarker()
				this.currentMarker.color = this.colors[0].NAME
				this.toggleMarkerPopup(true)
			},
			/*
				Редактирование маркера по клику на него
				е -- событие клика по маркеру
			*/
			clickMarker: function(e) {
				var markId = e.get('target').properties._data.markerId
				this.clearCurrentMarker()
				this.getCurrentMarker(markId)
				this.toggleMarkerPopup(true)
			},
			/*
				Нажатие кнопки редактирования маркера в списке маркеров
				markId -- id редактируемого маркера
			*/
			clickEditButton: function(markId) {
				this.clearCurrentMarker()
				this.getCurrentMarker(markId)
				this.toggleMarkerPopup(true)
			},
			/*
				Редактирование местоположения маркера перетаскиванием
				е -- событие окончания перетаскивания
			*/
			dragMarker: function(e) {
				var markId = e.get('target').properties._data.markerId
				this.clearCurrentMarker()
				this.getCurrentMarker(markId)
				this.currentMarker.coords = e.get('target').geometry.getCoordinates()
				this.updateMarkDataById(this.currentMarker.markerId)
				this.setMapBounds()
				this.c_value_map = this.map
			},
			/*
				Поиск маркера по id в списке
			*/
			getCurrentMarker: function(markId) {
				for (var i = 0, len = this.map.markers.length; i < len; i++) {
					if (this.map.markers[i].markerId === markId) {
						break;
					}
				}
				this.currentMarker = {
					markerId: this.map.markers[i].markerId,
					hintContent: this.map.markers[i].hintContent,
					coords: [this.map.markers[i].coords[0], this.map.markers[i].coords[1]],
					address: this.map.markers[i].address,
					phone: this.map.markers[i].phone,
					site: this.map.markers[i].site,
					desc: this.map.markers[i].desc.replace(/\\"/g,"'").replace(/">/g,"'>"),  //допилить UARM на тему экранирования последней кавычки в ссылке CWP-16144
					color: this.map.markers[i].color,
				}
			},
			/*
				Редактирование маркера по id в списке
			*/
			updateMarkDataById: function (markId) {
				for (var i = 0, len = this.map.markers.length; i < len; i++) {
					if (this.map.markers[i].markerId === markId) {
						this.map.markers[i] = this.currentMarker;
						break;
					}
				}
			},
			/*
				Удаление маркера по id в списке
			*/
			deleteCurrentMarker: function(markId) {
				this.map.markers = this.map.markers.filter(function(item) {
					return item.markerId != markId
				})
				this.toggleMarkerPopup(false)
				this.setMapBounds()
				this.c_value_map = this.map
			},
			/*
				Изменение области показа карты
			*/
			setMapBounds: function(e) {
				var marks = []
				if (this.map.markers.length != 0) {
					for (var i = 0; i < this.map.markers.length; i++) {
						marks.push(this.map.markers[i].coords)
					}
					var bounds = ymaps.util.bounds.fromPoints(marks)
					var centerAndZoom = ymaps.util.bounds.getCenterAndZoom(bounds, [500, 500])
					this.map.coords = centerAndZoom.center
					this.map.zoom = centerAndZoom.zoom > 17 ? 17 : centerAndZoom.zoom - 1
				}
			},
			/*
				Очистка вспомогательного маркера
			*/
			clearCurrentMarker: function() {
				this.currentMarker = {
					markerId: null,
					hintContent: null,
					coords: [null, null],
					address: null,
					phone: null,
					site: null,
					desc: null,
					color: null,
				}
			},
			/*
				Открытие окна Экспорта-импорта
			*/
			toggleImportExportPopup: function(bShow) {
				this.showImportExportPopup = !!bShow;
			},
			/*
				Нажатие кнопки Экспорта
			*/
			clickExportButton: function() {
				this.markersExp = JSON.stringify(this.map.markers)
				this.isImport = false
				this.toggleImportExportPopup(true)
			},
			/*
				Нажатие кнопки импорта
			*/
			clickImportButton: function() {
				this.markersExp = null
				this.isImport = true
				this.toggleImportExportPopup(true)
			},
			/*
				Нажатие кнопки Сохранить в окне Экспорта-импорта
			*/
			clickSaveMarkersButton: function() {
				try {
					this.map.markers = JSON.parse(this.markersExp.replace(/\\"/g,"'"));
					this.c_value_map = this.map
				}
				catch(err){
					alert('Код импорта невалиден');
					return;
				}
				this.setMapBounds()
				this.toggleImportExportPopup(false)
			},
			/*
				Нажать на колонку для сортировки
			*/
			sortMarkers: function(field, mode) {
				if (this.map.sortField != field || this.map.sortMode == null) {
					this.map.sortMode = true
				} else {
					this.map.sortMode = !this.map.sortMode
				}
				this.map.sortField = field
				this.map.markers.sort(this.byField(this.map.sortField, this.map.sortMode))
				this.c_value_map = this.map
			},
			/*
				Сортировка по полю
				field -- поле, по которому проводится сортировка
				mode (asc или desc) -- порядок сортировки по взрастанию или убыванию
			*/
			byField: function(field, mode) {
				return (a, b) => {
					if (mode) {
						return a[field] > b[field] ? 1 : -1
					} else {
						return a[field] < b[field] ? 1 : -1
					}

				}
			},
			/*
				Изменение цвета маркера
			*/
			changeMarkerColor: function(e) {
				this.currentMarker.color = e.target.dataset.name

			},
		},
		components: { yandexMap, ymapMarker, modal },
		mounted: function() {
			this.c_value_map = this.map
			// Получение списка цветов
			var path = urlUtil.wizDomainProxy.getPrePathTpl(this.$route.params.vpId) + '/ru/page/175610?mode=json'
			axios.get(path).then(response => {
            	this.colors = response.data.COLORS.CORPORATE_COLOR
          	})
		},

		computed: {
			c_value_map: {
				get: function() {
					return this.map
				},
				set: function(newVal) {
					this.$emit('input', JSON.stringify(newVal));
				}
			},
		},
	}
</script>

<style lang="css">
	.color-chooser {
		display: flex;
		padding-top: 10px;
	}
	.color {
		width: 60px;
		height: 40px;
		margin-right: 15px;
		cursor: pointer;
		border: 1px solid #000;
		border-radius: 8px;
	}
	.chosen {
		box-shadow: 0px 0px 10px green;
	}
	.marker-color {
		width: 30px;
		height: 30px;
		border: 1px solid #000;
		border-radius: 8px;
	}
</style>
